export default __webpack_public_path__ + "assets/icon-add-white.4e364ff3.webp";